import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const generateFreeworkshop = async (values) => {
  return await axios.post(`${baseURL}/generate-free-workshop`, values);
};
